import { Box } from '@mui/material';
import type { ComponentDefinition } from '@/admins/SmartReports/components/Components/types';
import { Placeholder } from '@/admins/SmartReports/components/Placeholders/Placeholder';
import { TextFieldPlaceholder } from '@/admins/SmartReports/components/Placeholders/TextFieldPlaceholder';
import { COMPONENT_TYPE_FALLBACK_THUMBNAIL } from '@/admins/SmartReports/constants';
import {
  SmartReportComponentTypesEnum,
  type SmartReportEntityExtended,
} from '@/admins/SmartReports/types';
import { type Portfolio, SmartReportEntityTypeEnum } from '@/types/GraphqlSchema';

export const buildPortfolioFromEntity = (
  entity: SmartReportEntityExtended | null | undefined,
): Portfolio => {
  const portfolio: Portfolio = {
    assets: [],
    countries: [],
    companies: [],
    basins: [],
  };

  if (!entity || !entity?.id || !entity?.type) {
    return portfolio;
  }

  switch (entity.type) {
    case SmartReportEntityTypeEnum.Asset:
      portfolio.assets = [Number(entity.id)];
      break;
    case SmartReportEntityTypeEnum.CountryArea:
      portfolio.countries = [Number(entity.id)];
      break;
    case SmartReportEntityTypeEnum.Company:
      portfolio.companies = [Number(entity.id)];
      break;
    default:
      break;
  }

  return portfolio;
};

export const getThumbnailComponent = <T,>(item: ComponentDefinition<T>) => {
  if (item.Thumbnail) {
    return item.Thumbnail;
  }

  const FallbackThumbnail = COMPONENT_TYPE_FALLBACK_THUMBNAIL[item.type];
  if (FallbackThumbnail) {
    return (props: React.PropsWithChildren<unknown>) => (
      <Box
        {...props}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '40px',
        }}
      >
        <FallbackThumbnail />
      </Box>
    );
  }
  return null;
};

export const getPlaceholderComponent = (accept: SmartReportComponentTypesEnum[]) => {
  // If accept includes ONLY TextField, show TextFieldPlaceholder
  if (accept?.includes(SmartReportComponentTypesEnum.TextField) && accept?.length === 1) {
    return TextFieldPlaceholder;
  }

  // Default to Placeholder
  return Placeholder;
};
